export interface XPEvent {
  source: string;
  amount: number;
}

// XP rewards par action
const XP_REWARDS: Record<string, number> = {
  daily_task_complete: 30,
  prestige: 100,
  raid_victory: 20,
  achievement_unlock: 50,
  building_upgrade_10: 10, // every 10 upgrades
  event_activate: 5,
};

export class XPManager {
  getXPForAction(action: string): number {
    return XP_REWARDS[action] ?? 0;
  }

  static getXPRewards(): Record<string, number> {
    return { ...XP_REWARDS };
  }
}
